import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';
import * as api from 'Api';
import * as utils from 'Utils';


class VisitorStore {

  @setter @observable productsPrompted;

  constructor() {
    this.reset();
  }

  @action reset() {
    this.productsPrompted = [];
  }

  getDeserializeMappers() {
    return [
      {"field": "productsPrompted", "accessor": "products_prompted"},
    ];
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  serialize() {
    const data = {
      'products_prompted': this.productsPrompted,
    };

    return data;
  }

  @action addProductsPrompted(productId) {
    if (!productId) return;
    productId = `${productId}`;

    if (this.productsPrompted.includes(productId)) return;
    this.productsPrompted.push(productId);
    this.postChanges();
  }

  postChanges() {
    const successCallback = (response) => {};
    const errorCallback = (error) => {};
    let cookieId = utils.getOrCreateCookieId();
    if (!cookieId) return;

    let payload = this.serialize();
    api.postUpdateBackInStockVisitor(successCallback, errorCallback, cookieId, JSON.stringify(payload));
  }
}


const visitorStore = new VisitorStore();
export default visitorStore;
export { VisitorStore };
